import { Signal } from '@modules';

/**
 * AttributesFeed component constants
 * @returns {variables}
 */

export const SIGNAL_TYPES: Signal['type'][] = ['textual', 'numeric'];
